










import {
    defineComponent,
    computed,
} from '@vue/composition-api';
import { getConfig } from '@superbet-group/web.lib.config';
import { SdsAlert } from '@superbet-group/web.lib.ui-components';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import countryIndex from '@store/modules/data/country/countryIndex';

export default defineComponent({
    name: 'WarningBannerContainer',
    setup() {
        const countryStore = useVuexStore<typeof countryIndex>('data/country');
        const config = countryStore.getter('config');

        const warningMessage = computed(() => {
            return config.value.applicationStatus.serviceMessageObject?.[getConfig().appLocale.locale]
                || config.value.applicationStatus.serviceMessage;
        });

        return {
            warningMessage,
            isDisplayed: computed(() => !!warningMessage.value),
        };
    },
    components: {
        SdsAlert,
    },
});
